import { Row, Col } from 'react-bootstrap'
import Navlogo from '../assets/images/Logo.png'
import Twitter from '../assets/images/twitter.png'

import Discord from '../assets/images/discord.png'

import Chat from '../assets/images/chat.png'

import { P } from './Typography'
import { Spacer } from './Spacer'

export default function Navbar({ tr, rr, fr }) {
  return (
    <>
      <Spacer height={'20px'} />
      <Row
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          margin: '0px',
          padding: '0px 20px 0px 20px',
        }}
      >
        <Col md={4} className="d-flex">
          <img width={'26px'} height={'26px'} src={Navlogo} alt="" />
          <P className="mx-2" onClick={() => tr.current.scrollIntoView()}>
            The Syndicatz
          </P>
        </Col>
        <Col md={4} className="d-flex justify-content-end  align-items-center">
          <img style={{ cursor: 'pointer' }} src={Discord} alt="" />
          <img
            style={{ cursor: 'pointer' }}
            className="mx-3"
            src={Twitter}
            alt=""
          />
          <img style={{ cursor: 'pointer' }} src={Chat} alt="" />
        </Col>
      </Row>
    </>
  )
}
